import { ReactNode, useEffect } from 'react';
import { cn } from './utils.js';

export interface ModalProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  children: ReactNode;
  className?: string;
}

export function Modal({ open, onClose, title, children, className }: ModalProps) {
  useEffect(() => {
    if (!open) return;
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 p-4"
      onClick={onClose}
    >
      <div
        className={cn('w-full max-w-lg rounded-xl bg-white p-6 shadow-xl', className)}
        onClick={(e) => e.stopPropagation()}
      >
        {title ? <h2 className="mb-4 text-lg font-semibold text-slate-900">{title}</h2> : null}
        {children}
      </div>
    </div>
  );
}
